import React from 'react'

import Modal from '~/components/NewModal'
import ButtonPrimary from '~/components/Button/ButtonPrimary'
import ButtonSecondary from '~/components/Button/ButtonSecondary'

import './modal-get-out.scss'

export default function ModalGetOut({ onSuccess, onError }) {
  return (
    <Modal>
      <div className="get-out">
        <div className="get-out-content">
          <h1>Você tem certeza que deseja sair?</h1>
        </div>
        <div className="get-out-actions">
          <ButtonSecondary onClick={onError}>Cancelar</ButtonSecondary>
          <ButtonPrimary onClick={onSuccess}>Sair</ButtonPrimary>
        </div>
      </div>
    </Modal>
  )
}